var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPianoRollCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 512,
    viewBox: "0 0 1024 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.25
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whiteKeyGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eef1f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blackKeyGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b3f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f1215"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 64,
    width: 128,
    height: 384,
    rx: 18,
    fill: "url(#whiteKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 154.88,
    y: 64,
    width: 74.24,
    height: 238.08,
    rx: 16,
    fill: "url(#blackKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.88,
    y: 64,
    width: 74.24,
    height: 238.08,
    rx: 16,
    fill: "url(#blackKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 538.88,
    y: 64,
    width: 74.24,
    height: 238.08,
    rx: 16,
    fill: "url(#blackKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 666.88,
    y: 64,
    width: 74.24,
    height: 238.08,
    rx: 16,
    fill: "url(#blackKeyGrad)",
    filter: "url(#softShadow)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 794.88,
    y: 64,
    width: 74.24,
    height: 238.08,
    rx: 16,
    fill: "url(#blackKeyGrad)",
    filter: "url(#softShadow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPianoRollCard);
export default __webpack_public_path__ + "static/media/piano-roll-card.90fa21c9255591849e63e5aebe7b69a6.svg";
export { ForwardRef as ReactComponent };